import React from "react";
import type { RootStore } from "./RootStore";
import StoreContext from "./StoreContext";

/**
 * Props interface following TypeScript naming convention
 */
interface StoreProviderProps {
  store: RootStore;
  children: React.ReactNode;
}

/**
 * Store Provider component
 * Wraps the app and provides access to all stores via context
 */
const StoreProvider = ({ store, children }: StoreProviderProps): React.ReactElement => {
    return (
        <StoreContext.Provider value={store}>
            {children}
        </StoreContext.Provider>
    );
};

export default StoreProvider;

